import $ from 'jquery'
import { Draw as olDrawInteraction } from 'ol/interaction'
import Tool from '../Tool'
import drawLayer from '../drawLayer'
import UndoVertex from './UndoVertex'

import { toValidGeometry } from '../ol'
import defaultDrawStyle from './defaultDrawStyle'
/**
 * Draw tool class
 *
 * @param {Object} config
 * @constructor
 */
export default class Draw extends Tool {
  constructor(config) {
    super()

    $.extend(this, config)

    var typeIconMap = {}
    typeIconMap['Point'] = 'fa fa-circle-o'
    typeIconMap['LineString'] = 'map-line'
    typeIconMap['Polygon'] = 'map-polygon'
    this.ui.iconClass = typeIconMap[this.type]
    this.interaction = new olDrawInteraction({
      source: drawLayer.getSource(),
      type: this.type,
      style: this.style || defaultDrawStyle()
    })

    this.useSnap = true
    this.undoVertex = new UndoVertex(this.interaction, this.map)

    const drawEndTrigger = this.api.draw.createTrigger()

    this.interaction.on('drawstart', () => {
      this.api.draw.createTrigger()
      this.undoVertex.activate()
    })

    this.interaction.on('drawend', e => {
      // If the geometry is polygon or multipolygon - make sure it is valid
      try {
        if (
          e.feature &&
          (e.feature.getGeometry().getType() === 'Polygon' ||
            e.feature.getGeometry().getType() === 'MultiPolygon')
        ) {
          e.feature.setGeometry(toValidGeometry(e.feature.getGeometry()))
        }
      } catch (e) {
        if (
          feature &&
          (feature.getGeometry().getType() === 'Polygon' ||
            feature.getGeometry().getType() === 'MultiPolygon')
        ) {
          feature.setGeometry(toValidGeometry(feature.getGeometry(), true))
        }
      }
      drawEndTrigger(e)
      this.undoVertex.deactivate()
    })

    this.interaction.on('propertychange', this.api.draw.createTrigger())
  }

  deactivate() {
    super.deactivate()
    this.undoVertex.deactivate()
  }
}
